import http, { url } from '../../http'

const API_URL = "emergency_prevention_actas"

class prevencionEmergenciasAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async getAll(page) {
    const response = await http(`${API_URL}?page=${page}`)
    return response
  } 

/*   async getAll(id, page) {
    const response = await http(`${API_URL}/companies/${id}?page=${page}`)
    return response
  }  */
 
  async get(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  }

  async getActas(id) {
    const response = await http(`${API_URL}/acta/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new prevencionEmergenciasAPI()